import { isObject } from '@develop/ia-utils'
import { parse, serialize } from 'cookie-es'
import { destr } from 'destr'
import { defineStore } from 'pinia'
import type { CookieModel, IaCookie } from '~/models/cookie'

export const useCookieManagerStore = defineStore('cookie-manager', () => {
  const requestCookies = ref<string>()

  const setCookie = ({ name, value, options }: CookieModel) => {
    if (process.client) {
      let convertedValue = ''
      try {
        convertedValue = isObject(value) ? JSON.stringify(value) : value
      } catch (error) {
        convertedValue = value
      }
      document.cookie = serialize(name, convertedValue, { ...options, path: '/' })
    }
  }

  const getCookie = <T>(name: IaCookie) => {
    const cookie = isClient ? document.cookie : (useRequestHeaders(['cookie']).cookie ?? '')
    const parsed = parse(cookie)

    return destr<T>(parsed[name])
  }

  const deleteCookie = (name: IaCookie, path?: string) => {
    document.cookie = serialize(name, '', { expires: new Date(0), path: path ?? '/' })
  }

  const saveRequestCookies = (cookie: string) => {
    set(requestCookies, cookie)
  }

  return {
    setCookie,
    getCookie,
    deleteCookie,
    saveRequestCookies,
    requestCookies,
  }
})
